// korns/src/pages/Products/Products.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import MUIDataTable from "mui-datatables";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Paper } from "@mui/material";
import useSave from "../../Hooks/useSave";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DataTable from "../../components/virtulizedTable/DataTable";
import Checkbox from "@mui/material/Checkbox";

export default function ProductList() {
  const [productGroups, setProductGroups] = useState([]);
  const [productSubCategorys, setProductSubCategorys] = useState([]);
  const [productUnitOfMeasures, setProductUnitOfMeasures] = useState([]);
  const [productProductionSheets, setProductProductionSheets] = useState([]);
  const [products, setProducts] = useState([]);
  const [productCategorys, setProductCategorys] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);

    fetchGraphql({
      query: `
      query productsPaged($limit: Int, $offset: Int) {
        productsPaged(limit: $limit, offset: $offset) {
          products {
            productId
            productCode
            productName
            productDescription
            productPrice
            priceByPound
            productCategory
            productSubCategory
            productUnitOfMeasure
            productAmount
            groupId
            groupCode
            productionSheet
            sortOrder
          }
          productsCount
        }
      }
    `,
      variables: {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      },
    }).then((result) => {
      setProducts(result.data.productsPaged.products);
      setTotalCount(result.data.productsPaged.productsCount);
      setIsLoading(false);
    });
  }, [page, rowsPerPage]);

  const { fetchGraphql, DialogSave } = useSave(null);

  const columns = [
    {
      id: "productId",
      display: false,
    },
    {
      id: "productCode",
      name: "Code",
      maxWidth: "75px",
    },
    {
      id: "productName",
      name: "Name",
      minWidth: "200px",
    },
    {
      id: "productDescription",
      name: "Description",
      minWidth: "250px",
    },
    {
      id: "productPrice",
      type: "number",
      name: "Price",
      align: "right",
      minWidth: "140px",
    },
    {
      id: "priceByPound",
      name: "Price By Pound",
      editComponent: {
        type: "checkbox",
      },
      options: {
        customCell: (value) => <Checkbox checked={value} />,
      },
    },
    {
      id: "productCategory",
      name: "Category",
      minWidth: "250px",
      editComponent: {
        type: "selectField",
        values: productCategorys.map((item) => ({
          title: item,
        })),
        onChange: (newValue, setRowCopy, rowCopy) => {
          setRowCopy({
            ...rowCopy,
            productCategory: newValue?.title || null,
          });
        },
      },
    },
    {
      id: "productSubCategory",
      name: "Sub Category",
      minWidth: "250px",
      editComponent: {
        type: "selectField",
        values: productSubCategorys?.map((item) => ({
          title: item,
        })),
        onChange: (newValue, setRowCopy, rowCopy) => {
          setRowCopy({
            ...rowCopy,
            productSubCategory: newValue?.title || null,
          });
        },
      },
    },
    {
      id: "productUnitOfMeasure",
      name: "UOM",
      minWidth: "200px",
      editComponent: {
        type: "selectField",
        values: productUnitOfMeasures.map((item) => ({
          title: item,
        })),
        onChange: (newValue, setRowCopy, rowCopy) => {
          setRowCopy({
            ...rowCopy,
            productUnitOfMeasure: newValue?.title || null,
          });
        },
      },
    },
    {
      id: "productAmount",
      name: "Amount",
    },
    {
      id: "sortOrder",
      name: "Sort Order",
      type: "number",
      maxWidth: "100px",
    },
    {
      id: "groupCode",
      name: "Group",
      minWidth: "200px",
      editComponent: {
        type: "selectField",
        values: productGroups?.map((item) => ({
          ...item,
          title: item.groupCode,
        })),
        onChange: (newValue, setRowCopy, rowCopy) => {
          setRowCopy({
            ...rowCopy,
            groupCode: newValue?.title || null,
            groupId: newValue?.groupId || null,
          });
        },
      },
    },
    {
      id: "productionSheet",
      name: "Production Sheets",
      minWidth: "200px",
      editComponent: {
        type: "multipleSelect",
        values: productProductionSheets,
        onChange: (newValue, setRowCopy, rowCopy) => {
          setRowCopy({
            ...rowCopy,
            productionSheet: newValue || null,
            // groupId: newValue?.groupId || null,
          });
        },
      },
    },
  ];

  const options = {
    columnAlign: "left",
    columnMinWidth: "100px",
    serverSide: true,
    pagination: true,
    count: totalCount,
    page,
    rowsPerPage,

    onChangePage: (newPage) => {
      setPage(newPage);
    },

    onChangeRowsPerPage: (num) => {
      setRowsPerPage(num);
      setPage(0);
    },

    onRowClick: (rowCopy) => {
      console.log("edit");
      console.log(rowCopy);
      fetchGraphql({
        query: `query Query($productCategory: String) {
          productUnitOfMeasures
          productSubCategorys(productCategory: $productCategory)
          productCategorys
          productProductionSheets
        }`,
        variables: { productCategory: rowCopy.productCategory },
      }).then((result) => {
        setProductCategorys(result.data.productCategorys);
        setProductSubCategorys(result.data.productSubCategorys || []);
        setProductUnitOfMeasures(result.data.productUnitOfMeasures);
        setProductProductionSheets(result.data.productProductionSheets);
      });
    },
    save: (rowCopy, row) => {
      const copyState = [...products];

      const product = copyState.find(
        (item) => item["productId"] === row.productId,
      );

      const productIndex = copyState.findIndex(
        (item) => item["productId"] === row.productId,
      );

      const { productId, groupCode, ...newProduct } = rowCopy;

      if (product.productId.includes("new")) {
        return fetchGraphql({
          query: `mutation CreateProduct($product: ProductInput) {
            createProduct(product: $product)
          }`,
          variables: {
            product: {
              ...newProduct,
              productAmount: parseFloat(newProduct.productAmount),
            },
          },
        }).then((result) => {
          rowCopy.productId = result.data.createProduct;

          copyState[productIndex] = rowCopy;

          setProducts(copyState);

          return Promise.resolve("done");
        });
      } else {
        // console.log("old");
        return fetchGraphql({
          query: `mutation UpdateProduct($productId: ID, $product: ProductInput) {
            updateProduct(productId: $productId, product: $product)
          }`,
          variables: {
            product: {
              ...newProduct,
              productAmount: parseFloat(newProduct.productAmount),
            },
            productId: product.productId,
          },
        }).then((result) => {
          newProduct.productId = product.productId;

          copyState[productIndex] = rowCopy;

          setProducts(copyState);
        });
      }
    },
    delete: (row) => {
      const copyState = [...products];

      const productIndex = copyState.findIndex(
        (item) => item["productId"] === row.productId,
      );

      if (!row.productId.includes("new")) {
        fetchGraphql({
          query: `mutation DeleteProduct($productId: ID) {
            deleteProduct(productId: $productId)
          }`,
          variables: {
            productId: row["productId"],
          },
        }).then((result) => {
          copyState.splice(productIndex, 1);

          setProducts(copyState);
        });
      } else {
        copyState.splice(productIndex, 1);

        setProducts(copyState);
      }
    },
    newRecord: (setEditIndex, setRowCopy) => {
      const copyState = [...products];

      const newProduct = {
        productId: `new${products.length + 1}`,
        productCode: "",
        productName: "",
        productDescription: "",
        productCategory: "",
        sortOrder: null,
        productPrice: null,
        priceByPound: null,
        productSubCategory: null,
        productUnitOfMeasure: null,
        productAmount: null,
        groupId: null,
        groupCode: null,
        productionSheet: null,
      };

      copyState.push(newProduct);

      setRowCopy(newProduct);

      setProducts(copyState);

      setEditIndex({ rowIndex: copyState.length - 1, columnIndex: 0 });
    },
    fob: (setEditIndex, setRowCopy) => {
      const copyState = [...products];

      const newIngredient = {
        productId: `new${products.length + 1}`,
        productCode: "",
        productName: "",
        productDescription: "",
        productCategory: "",
        sortOrder: null,
        productPrice: null,
        priceByPound: null,
        productSubCategory: null,
        productUnitOfMeasure: null,
        productAmount: null,
        groupId: null,
        groupCode: null,
        productionSheet: null,
      };

      copyState.push(newIngredient);

      setRowCopy(newIngredient);

      setProducts(copyState);

      setEditIndex({ rowIndex: copyState.length - 1, columnIndex: 1 });
    },
    isLoading,
  };

  return (
    <>
      <DialogSave />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"There Is another item with this code."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please change it.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Paper
        sx={{
          width: "100%",
          height: "150%",
          marginLeft: "20px",
          padding: "20px",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ mb: 2, alignSelf: "flex-start" }}
          onClick={() => navigate("/products/products/new")}
        >
          New Product
        </Button>

        <DataTable rows={products} columns={columns} options={options} />
      </Paper>
    </>
  );
}
